export const options = { next: { revalidate: 30 } }

export const links = [
  { href: '/', label: 'Home' },
  { href: '/about', label: 'About us' },
  { href: '/products', label: 'Our products' },
  { href: '/news', label: 'News' },
  { href: '/contacts', label: 'Contacts' },
]
